import axios from 'axios';
import logger from './logService';
import { error as err } from './../components/common/toast';
import { logout } from './authService';

// To set cookie from server, withCredentials should be set true
axios.defaults.withCredentials = true;

// Request interceptor for API calls
axios.interceptors.request.use(
  (config) => {
    config.headers['Strict-Transport-Security'] = 'max-age=31536000';
    config.headers['Content-Security-Policy'] =
      "default-src 'self'; frame-ancestors 'none'";
    config.headers['X-Frame-Options'] = 'DENY';
    config.headers['X-XSS-Protection'] = '1; mode=block';
    config.headers['X-Content-Type-Options'] = 'nosniff';
    config.headers['Referrer-Policy'] = 'same-origin';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for API calls
axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
  if (error && error.response && error.response.status === 401) {
    localStorage.removeItem('security');
    const expirycheck = sessionStorage.getItem('session');
    if (expirycheck) {
      if (new Date(expirycheck) < new Date()) {
        logout();
        window.location = '/login';
        setTimeout(err('Session expired'), 3000);
      }
    }
    sessionStorage.clear();
  }
  if (!expectedError) err('An unexpected error occured');
  logger.log(error);

  return Promise.reject(error); //dont execute
});

//sets auth header
function setJwt(jwt) {
  if (jwt) axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt
};
